<template>
	<div class="promotion-item" v-if="promotion">
		<div class="post-box">
			<img class="banner-image" :src="promotion.banner_image"/>
		</div>
		<div class="element-box">
			<h2 class="form-header">{{ promotion.title }}</h2>
			<div class="form-desc" v-html="promotion.description"></div>
			<div class="element-box-content text-left"  v-html="promotion.terms">
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'promotionDetail',
        props: {
            pid: {
                default: null,
            },
            more: {
                default: 1
            }
        },
        data () {
            return {
                msg: '',
                t: this.$root.t,
                session:  this.$root.session,
	            promotion: null
            }
        },
	    mounted () {
            this.getDetail()
	    },
        methods:
            {
	            getDetail () {
                    this.$http.get(api+'api/v1/promotion/'+this.pid).then(response => {

                        if (response.body.result) {
                            this.promotion = response.body.result;
                        }

	                }, response => {
	                        // error callback
	                });
	            }
            }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.banner-image {
		width: 100%
	}
</style>



// WEBPACK FOOTER //
// src/components/promotion/detail.vue